import { render } from "./AccountClass.vue?vue&type=template&id=d7298792&scoped=true"
import script from "./AccountClass.vue?vue&type=script&lang=js"
export * from "./AccountClass.vue?vue&type=script&lang=js"

import "./AccountClass.vue?vue&type=style&index=0&id=d7298792&scoped=true&lang=css"

import exportComponent from "D:\\xampp7\\htdocs\\24x7pos\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7298792"]])

export default __exports__